import { render } from "./NavbarLeft.vue?vue&type=template&id=4bb4d08c&scoped=true&ts=true"
import script from "./NavbarLeft.vue?vue&type=script&lang=ts"
export * from "./NavbarLeft.vue?vue&type=script&lang=ts"

import "./NavbarLeft.vue?vue&type=style&index=0&id=4bb4d08c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb4d08c"]])

export default __exports__